import type { IOutcomeConsensus } from "~/types/event";
import { formatCents } from "~/utils/formatPrice";

export const getPriceBreakdown = (
  outcome: IOutcomeConsensus | null
): string =>
  `Standard Average: ${formatCents(outcome?.averageChance)}
The simple average of Yes prices across all listed platforms.

VWAP (Volume-Weighted): ${formatCents(outcome?.chance)}
Price weighted for trading volume; represents market conviction and where trading activity is concentrated.

Liquidity-Adjusted:  ${formatCents(outcome?.liquidityWeightedChance)}
Price weighted by available liquidity in the order book. Reflects current market depth.`;
